<template>
  <div class="row no-gutters">

    <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-4 changePassword">

      <div class="w-100">

        <div>
          <img class="logo-img" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo Login">
        </div>

        <div id="login-div">

          <b-alert :show="showError" variant="danger" class="mt-4">{{ textError }}</b-alert>

          <b-alert :show="showSuccess" variant="success" class="mt-4">{{$t('account.activation.successful')}}</b-alert>

        </div>

      </div>
    </div>

    <div id="col-right-with-image" class="col-sm-12 col-md-12 col-lg-8 d-lg-block d-xl-block" :style="{'background-image': 'url(' + require(`@/assets/images/b122/login-background.png`) + ')'}">
    </div>

  </div>

</template>

<script>

import api from "../../services/api";

export default {

  name: "ActivateAccount",

  data() {
    return {

      token: this.$route.params.token,
      language: this.$route.params.language,

      showSuccess: false,
      showError: false,
      textError: "",
    }
  },

  mounted() {
    this.checkToken()
  },

  methods: {

    checkToken() {

      let data = new FormData()
      data.append('token', this.token)
      data.append('language', this.language)

      api({
        method: 'POST',
        url: `/accountActivation/activateAccount`,
        data: data
      }).then((response) => {
          if(response.status === 200){
            this.showSuccess = true
            this.showError = false
          }
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.textError = error.response.data.message
            this.showError = true
          }
        });
    },

  }

};
</script>

<style scoped>

#col-right-with-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: center;
  height: 100vh;
}

#col-left-with-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5%;
  padding-left: 5%;
  height: 100vh;
}

@media (max-width: 992px) {
  #col-right-with-image {
    display: none;
  }
  #col-left-with-text {
    display: block;
  }
  .w-100 {
    min-height: 100vh;
    margin-top: min(150px, 50%);
  }
  .logo-img {
    max-width: 400px;
  }
  #login-div{
    margin-top: 200px;
  }

}

@media (max-height: 700px) {
  .w-100 {
    margin-top: min(150px,50%);
  }

  #col-right-with-image {
    height: 100vh;
  }

}

.logo-img {
  max-height: 140px;
  position: absolute;
  left: 0;
  top: 10%;
  width: 80%;
}

h1 {
  font-size: var(--title-level-one-font-size);
}

h2 {
  font-size: var(--title-level-two-font-size);
}

.changePassword {
  background-color: var(--secondary-color);
}
</style>



// WEBPACK FOOTER //
// src/views/auth/ActivateAccount.vue